/**
 * 导入数据对应表
 */
export const USER_RELATIONS = {
  客户名称: 'customerName',
  账户UUID: 'accountUuid',
  账户名称: 'accountName',
  产品: 'product',
  应收金额: 'receivableMoney',
  应收时间: 'receivableTime',
  所属人: 'belongUserName'
}

export const STATEMENT_RELATIONS = {
  账户UUID: 'accountUuid',
  账户名称: 'accountName',
  消耗日期: 'recordTime',
  消耗金额: 'recordMoney'
}

export const BANK_COLLECT_RELATIONS = {
  收款编号: 'collectCode',
  打款时间: 'collectTime',
  付款人名称: 'payName',
  客户名称: 'customerName',
  打款金额: 'payMoney',
  收款银行: 'collectBank',
  已核销金额: 'writeOffMoney',
  是否核销完毕: 'isOver'
}

export const FORMAL_RELATIONS = {
  客户名称: 'customerName',
  简称: 'simpleName',
  客户类型: 'customerType',
  授信额度: 'creditLimit',
  可用额度: 'availableCredit',
  行业: 'customerIndustry',
  所属人: 'belongUser',
  产品名称: 'productName',
  运营类型: 'operationType',
  返点: 'rebate'
}

export const ACCOUNT_EXPORT_RELATIONS = {
  推广账户名称: 'accountName',
  推广账户UID: 'accountUuid',
  所属产品: 'productName',
  返点: 'rebate',
  补充返点: 'supplyRebate',
  客户名称: 'customerName',
  所属运营: 'belongOperation',
  归属人: 'belongOpp',
  操作者: 'operator',
  结算方式: 'balanceStyle'
}

export const INVOICE_EXPORT_RELATIONS = {
  客户名称: 'customerName',
  开票主体: 'invoiceTitle',
  我方主体: 'ownEntity',
  红字标识: 'redType',
  状态: 'statusText',
  开票金额: 'money',
  发票类型: 'invoiceType',
  开票类目: 'invoiceCate',
  是否超开: 'isOver',
  超开金额: 'overMoney',
  开票水单: 'url',
  开票类型: 'type',
  所属商务: 'belongUser'
}

export const FORMAL_ORDER_EXPORT_RELATIONS = {
  订单id: 'id',
  推广账户名称: 'accountName',
  推广账户UID: 'accountUuid',
  客户名称: 'customerName',
  所属产品: 'productName',
  充值现金: 'chargeMoney',
  服务费: 'serviceCharge',
  充值币数: 'coins',
  返点: 'rebate',
  补充返点: 'supplyRebate',
  类型: 'type',
  状态: 'status',
  回退原因: 'reback',
  充值时间: 'chargeTime',
  创建时间: 'creatTime',
  操作人: 'operator'
}

export const FORMAL_ORDER_EXPORT_TIME_RELATIONS = {
  订单ID: 'id',
  推广账户名称: 'accountName',
  推广账户UID: 'accountUuid',
  客户名称: 'customerName',
  所属产品: 'productName',
  充值现金: 'chargeMoney',
  服务费: 'serviceCharge',
  充值币数: 'coins',
  返点: 'rebate',
  补充返点: 'supplyRebate',
  类型: 'type',
  状态: 'status',
  回退原因: 'reback',
  充值时间: 'chargeTime',
  创建时间: 'creatTime',
  充值状态: 'chargeState',
  核销状态: 'writeOffState',
  操作人: 'operator'
}

export const MEDIA_RECORD_RELATIONS = {
  推广账户名称: 'accountName',
  推广账户UID: 'accountUuid',
  客户名称: 'company',
  所属产品: 'belongPro',
  消耗日期: 'recordTime',
  消耗: 'recordMoney',
  现金: 'payCrash',
  毛利: 'gross',
  返点: 'rebate',
  补充返点: 'supplyRebate',
  所属人: 'belongUser'
}

export const CUSTOMER_PRODUCT_RELATIONS = {
  客户名称: 'customerName',
  产品类型: 'proType',
  运营类型: 'operationType',
  返点: 'rebate',
  补充返点: 'supplyRebate',
  结算方式: 'balanceStyle',
  结算周期: 'balanceTime',
  月结时间: 'balanceReminder',
  所属商务: 'belongUser'
}

export const OPP_RELATIONS = {
  客户名称: 'company',
  联系人姓名: 'name',
  联系人职位: 'contactPosition',
  联系人手机号: 'customerContact',
  微信号: '微信号',
  合作媒体: 'customerMedia',
  客户行业: 'customerIndustry',
  客户规模: 'customerLevel',
  客户情况: 'customerProfile',
  归属人姓名: 'belongUser',
  创建人姓名: 'createuser'
}
